<template>
  <div>
    <h5 v-if="loading">
      {{ $t("loginpage.captcha.waiting") }}
    </h5>
    <h5 v-if="!loading">
      {{ $t("loginpage.captcha.title") }}
    </h5>

    <div id="captchetat" />

    <div class="p-input mb-3">
      <InputText
        id="captchaCode"
        v-model="captchaAnswer"
        :placeholder="$t('loginpage.captcha.placeholder')"
        class="col-12 lg:col-4 mt-2"
        type="text"
        autocomplete="email"
      />
    </div>
  </div>
</template>
<script>
import InputText from "primevue/inputtext";

export default {
  name: 'CaptchaComponent',
  components: {InputText},
  props: {
    session: {
      type: String,
      default: null
    },
    answer: {
      type: String,
      default: null
    }
  },
  emits: ['update:session', 'update:answer'],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    urlBackend() {
      return process.env.NODE_ENV === process.env.NODE_ENV === 'development' ? 'http://localhost:9000/api/captcha' : window.origin + window.location.pathname + 'api/captcha';
    },
    captchaSession: {
      get() {
        return this.session;
      },
      set(value) {
        this.$emit('update:session', value);
      }
    },
    captchaAnswer: {
      get() {
        return this.answer;
      },
      set(value) {
        // Retrieves the captcha uuid stored in a hidden element within the captcha container
        this.captchaSession = document.getElementById('captchetat-uuid')?.value
        this.$emit('update:answer', value);
      }
    }
  },
  mounted() {
    this.initCaptcha();
  },
  methods: {
    initCaptcha() {
      const captchaType = this.$i18n.locale === 'fr' ?
        this.$store.getters['setting/getCaptchaTypeFr'] :
        this.$store.getters['setting/getCaptchaTypeEn'];
      // Dynamically changes the captchaStyleName attribute based on the lang and the associated configuration
      document.getElementById("captchetat").setAttribute('captchaStyleName', captchaType);

      // Dynamically changes te backend url used
      document.getElementById("captchetat").setAttribute('urlBackend', this.urlBackend);

      window.dispatchEvent(new Event('load'));
    },

    async reload() {
      this.loading = true;
      // Uses the method exposed by the captchetat-js script to refresh the captcha
      await window.captchetatComponentModule.refreshCaptcha()
      this.loading = false;
    }
  }
}

</script>
